import React, { useState, useEffect, Fragment } from "react";
import { Spinner } from "react-bootstrap";
import axiosInstance from "../../services/AxiosInstance";
import swal from "sweetalert";

const PaymentSettings = () => {
  const [loading, setLoading]   = useState(true);
  const [saving, setSaving]     = useState(false);

  const [mode, setMode]                         = useState("test");
  const [liveKeyId, setLiveKeyId]               = useState("");
  const [liveKeySecret, setLiveKeySecret]       = useState("");
  const [testKeyId, setTestKeyId]               = useState("");
  const [testKeySecret, setTestKeySecret]       = useState("");

  useEffect(() => { loadSettings(); }, []);

  const loadSettings = async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get("packs/settings/razorpay");
      if (data.status && data.settings) {
        const s = data.settings;
        setMode(s.razorpayMode || "test");
        setLiveKeyId(s.razorpayKeyId || "");
        setLiveKeySecret(s.razorpayKeySecret || "");
        setTestKeyId(s.razorpayTestKeyId || "");
        setTestKeySecret(s.razorpayTestKeySecret || "");
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const onSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await axiosInstance.post("packs/settings/razorpay", {
        razorpayMode:         mode,
        razorpayKeyId:        liveKeyId,
        razorpayKeySecret:    liveKeySecret,
        razorpayTestKeyId:    testKeyId,
        razorpayTestKeySecret: testKeySecret,
      });
      if (data.status) {
        swal("Saved!", "Razorpay settings updated successfully.", "success");
      } else {
        swal("Error", data.message, "error");
      }
    } catch (e) { swal("Error", e.message, "error"); }
    setSaving(false);
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <Fragment>
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title mr-auto">Payment Settings — Razorpay</h4>
          </div>
          <div className="card-body">
            <form onSubmit={onSave}>

              {/* ── Mode Toggle ──────────────────────────────────────────── */}
              <div className="row mb-4">
                <div className="form-group col-md-4">
                  <label className="text-black font-w500">Razorpay Mode</label>
                  <select className="form-control" value={mode} onChange={e => setMode(e.target.value)}>
                    <option value="test">Test (Sandbox)</option>
                    <option value="live">Live (Production)</option>
                  </select>
                  <small className="text-muted">
                    {mode === "live"
                      ? "⚠️ Live mode — real payments will be processed."
                      : "🧪 Test mode — no real payments."}
                  </small>
                </div>
              </div>

              <hr />

              {/* ── Live Keys ────────────────────────────────────────────── */}
              <h6 className="text-primary mb-3">Live Keys</h6>
              <div className="row mb-4">
                <div className="form-group col-md-6">
                  <label className="text-black font-w500">Live Key ID</label>
                  <input type="text" className="form-control" value={liveKeyId}
                    onChange={e => setLiveKeyId(e.target.value)}
                    placeholder="rzp_live_xxxxxxxxxxxx" autoComplete="off" />
                </div>
                <div className="form-group col-md-6">
                  <label className="text-black font-w500">Live Key Secret</label>
                  <input type="password" className="form-control" value={liveKeySecret}
                    onChange={e => setLiveKeySecret(e.target.value)}
                    placeholder="Live secret key" autoComplete="new-password" />
                </div>
              </div>

              <hr />

              {/* ── Test Keys ────────────────────────────────────────────── */}
              <h6 className="text-primary mb-3">Test Keys</h6>
              <div className="row mb-4">
                <div className="form-group col-md-6">
                  <label className="text-black font-w500">Test Key ID</label>
                  <input type="text" className="form-control" value={testKeyId}
                    onChange={e => setTestKeyId(e.target.value)}
                    placeholder="rzp_test_xxxxxxxxxxxx" autoComplete="off" />
                </div>
                <div className="form-group col-md-6">
                  <label className="text-black font-w500">Test Key Secret</label>
                  <input type="password" className="form-control" value={testKeySecret}
                    onChange={e => setTestKeySecret(e.target.value)}
                    placeholder="Test secret key" autoComplete="new-password" />
                </div>
              </div>

              <div className="mt-2">
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  {saving ? "Saving…" : "Save Settings"}
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PaymentSettings;
